import './ProductItemGridViewLayout.scss';

import classnames, { createClsNameMap } from '@utils/classnames';

import ProductLink from '@/features/filter-product-list/product-list/product-item/ProductLink';

import ProductItem from '../ProductItem';
import type { ProductItemProps } from '../types';

const clsNameMap = createClsNameMap({
  elements: {
    info: createClsNameMap(),
    image: createClsNameMap(),
    'cta-buttons': createClsNameMap(),
  },
})('product-item-grid-view-layout');

export type ProductItemGridViewLayoutProps = ProductItemProps & { hasCollection: boolean };

export const ProductItemGridViewLayout = (props: ProductItemGridViewLayoutProps) => {
  const { productInfo, productImg, popupSelectOption, productDetailUrl } = props;

  return (
    <ProductItem {...props} className={clsNameMap.root()}>
      <div className={clsNameMap.elm('image')}>
        <ProductLink href={productDetailUrl} className={classnames('product-link-image')}>
          <div style={{ position: 'relative' }}>
            {productImg}
            {popupSelectOption}
          </div>
        </ProductLink>
      </div>
      <ProductLink href={productDetailUrl}>{productInfo}</ProductLink>
    </ProductItem>
  );
};
